<div *ngIf="bvError" data-test="error-banner">
  <span class="scroll-anchor" #bvErrorBannerContainer></span>
  <sonder-success-error-banner [isSuccess]="false" [message]="bvError"></sonder-success-error-banner>
</div>

<form [formGroup]="eapInfoForm" (ngSubmit)="submit()">
  <div *ngIf="!useInline">
    <h3>Add an Employee Assistance Program</h3>
    <p class="iris-body-responsive">
      Employee Assistance Programs (EAPs) cover the cost of a preset number
      of therapy sessions, so you’re not responsible for any payment. Once you’ve
      used your preset sessions, you can choose to continue using your insurance
      or credit/debit card.
    </p>
  </div>

  <iris-form-field
    class="form-container"
    label="EAP state"
    required="true"
  >
    <iris-dropdown
      formControlName="eapState"
      [options]="usStateOption"
      placeholder="Choose your EAP state"
      data-test="eap-state-dropdown"
    >
    </iris-dropdown>
  </iris-form-field>

  <iris-form-field label="EAP provider" required="true">
    <iris-dropdown
      [options]="eapListOptions$ | async"
      formControlName="eapProvider"
      placeholder="Choose your EAP provider"
      data-test="eap-provider-dropdown"
    >
    </iris-dropdown>
  </iris-form-field>

  <span
    class="help-container form-container"
    sonderPopupTrigger
    [popup]="providerHelp"
  >
    <iris-icon
      name="info"
      [size]="iconSizes.MD"
      class="provider-id-icon"
      ariaLabel="state-provider-help"
    ></iris-icon>&nbsp;
    <a data-test="insurance-confirm-paragraph-text">I don't see my EAP state or provider</a>
    <sonder-popup
      #providerHelp
      [closeOnClick]="true"
      [offsetY]="-32"
    >
      If you don't see your EAP provider listed when you filter by your state,
      unfortunately we do not accept your EAP at this time.
      <br>
      <br>
      We know EAPs can be complicated. Call us at
      <a href="tel:{{ supportPhoneLink }}">{{ supportPhoneDisplay }}</a>
      if you need help.
    </sonder-popup>
  </span>

  <iris-form-field
    [ngClass]="{'eap-form-field-full' : useInSessionRequest, 'eap-form-field-half' : !useInSessionRequest}"
    label="Authorization number"
    [helperText]="authNumFormatExample"
    [customErrorMessages]="authNumberErrorMessages"
    data-test="eap-authorization-header-text"
  >
    <iris-text-input
      formControlName="authorizationNumber"
      placeholder="Enter number"
      data-test="eap-authorization-input"
    >
    </iris-text-input>
  </iris-form-field>
  <span
    class="help-container"
    sonderPopupTrigger
    [popup]="authNumberHelp"
  >
    <iris-icon
      name="info"
      [size]="iconSizes.MD"
      class="provider-id-icon"
      ariaLabel="state-provider-help"
    ></iris-icon>&nbsp;
    <a data-test="insurance-confirm-paragraph-text">What is this number used for?</a>
    <sonder-popup
      #authNumberHelp
      [closeOnClick]="true"
      [offsetY]="-32"
    >
      This number allows us to use your benefits.
      If you don’t have it now, make sure to find it
      and reach out to us at <a href="tel:{{ supportPhoneLink }}">{{ supportPhoneDisplay }}</a>
      before your first session.
    </sonder-popup>
  </span>

  <div class="date-filter-pickers">
    <sonder-form-field label="Start date" errorDisplayPosition="bottom">
      <input
        matInput
        [matDatepicker]="startDatePicker"
        placeholder="MM/DD/YYYY"
        formControlName="startDate"
        data-test="eap-start-date-input"
      >
      <mat-datepicker-toggle matSuffix [for]="startDatePicker">
        <iris-icon name="date_range" [size]="iconSizes.MD" matDatepickerToggleIcon></iris-icon>
      </mat-datepicker-toggle>
      <mat-datepicker [touchUi]="isMobile$ | async" #startDatePicker></mat-datepicker>
    </sonder-form-field>

    <sonder-form-field label="End date" errorDisplayPosition="bottom">
      <input
        matInput
        [min]="eapInfoForm.controls['startDate'].value"
        [matDatepicker]="endDatePicker"
        placeholder="MM/DD/YYYY"
        formControlName="endDate"
        data-test="eap-end-date-input"
      >
      <mat-datepicker-toggle matSuffix [for]="endDatePicker">
        <iris-icon name="date_range" [size]="iconSizes.MD" matDatepickerToggleIcon></iris-icon>
      </mat-datepicker-toggle>
      <mat-datepicker [touchUi]="isMobile$ | async" #endDatePicker></mat-datepicker>
    </sonder-form-field>
  </div>

  <iris-form-field
    [ngClass]="{'eap-form-field-full' : useInSessionRequest, 'eap-form-field-half' : !useInSessionRequest}"
    class="form-container"
    label="Number of EAP sessions"
    helperText="Enter the number of EAP sessions you are authorized for between 1 and 100."
    [customErrorMessages]="eapSessionCountErrorMessages"
  >
    <iris-text-input
      formControlName="eapSessionCount"
      type="number"
      [min]="1"
      [max]="100"
      placeholder="Enter number of EAP sessions available"
      data-test="eap-session-count-input"
    >
    </iris-text-input>
  </iris-form-field>

  <iris-button-container *ngIf="!useInline" [alignment]="IrisButtonContainerAlignments.END">
    <iris-button
      [type]="IrisButtonTypes.PRIMARY"
      [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
      [disabled]="submitting || eapInfoForm.invalid"
      data-test="eap-save-button"
    >
      <span *ngIf="!submitting; else spinner">
        Save
      </span>
      <ng-template #spinner>
        <mat-spinner diameter="24"></mat-spinner>
      </ng-template>
    </iris-button>
  </iris-button-container>

</form>
